<template>
	<div>

		<p>Colonne à ajoutée
			<b-select v-show="columns.length > 0" style="width: 300px" @change="insert_column" :options="columns" v-model="column" />
			<b-button variant="link" @click="insert_column(column)"><i class="fas fa-plus"></i></b-button>
		</p>
		<div :style="style" ref="editor" :id="'editor' + id_editor" :contenteditable="true">
		</div>

		<br />
	</div>
</template>

<script>
	import store from "../store";
	import users from "../services/users.js";
	import edit_tabulator from "../components/edit_tabulator.vue";
	import text_columns from "../components/text_helpers/columns.vue";

	import Vue from 'vue';
    import uniqueId from "lodash.uniqueid";

	var tools = require("../utils/Tools");

	export default {
        name: "textarea_plus",
		components: {
			edit_tabulator,
		},
		data() {
			return {
				test_data: "",
				message: "",
				id: 0,
				ids: {},
				code: "",
                is_div: 0,
				id_editor: uniqueId(),
				column: ""
			};
        },
        props: {
            columns: {
                default: () => []
            },
			height: {
				default: 300
			}
        },
		computed: {
			// un accesseur (getter) calculé
			style: function () {
				// `this` pointe sur l'instance vm
				return `background-color:white; border: 1px solid black;padding: 5px; height: ${this.height}px; max-height: ${this.height}px; overflow: auto;`
			},
		},
		methods: {
			generate_nodes(nodes, code, level)
			{
				//console.log(nodes)

				if (nodes.childNodes)
					nodes = nodes.childNodes;

				for (var i = 0; i < nodes.length; i++)
				{
					
					//console.log(nodes[i])
					if (this.ids[nodes[i].id])
					{
						code += this.ids[nodes[i].id].save();
						this.is_div = false;
					}
					else
					{
						if (nodes[i].innerHTML)
						{
							if (!this.is_div)
								code += "\n";
							code = this.generate_nodes(nodes[i].childNodes, code, level++);
							code += "\n";
							this.is_div = true;
						}
						else
						{
							//console.log("---")
							if (nodes[i].nodeName != "BR" && nodes[i].data)
								code += nodes[i].data;
							/*if (level == 0)
								this.is_div = false;
							else*/
							this.is_div = false;
						}
					}
				}
				return code
            },
            load(data)
            {
				//console.log(data)
				if (data)
				{
					this.code = data;
					this.load_code();
				}
            },
            save()
            {
                return {data: this.save_code()};
            },
            get_data()
            {
                return this.save_code();
            },
			save_code()
			{
				//console.log("generate");

				//console.log(this.ids);

				this.code = "";

				var nodes = document.getElementById("editor" + this.id_editor);
				this.code = this.generate_nodes(nodes, "", 0);
				this.code = this.code.replace(/&nbsp;/g, " ").trim().replace(/\\n$/, "");
				//console.log(this.code)

				return this.code;
			},
			load_code()
			{
				var self = this;

				var editor = document.getElementById("editor" + this.id_editor);
				editor.innerHTML= "";

				var code = this.code;
				code = code.split("\n");
				//console.log(code)
				var text = "";
				for (var i = 0; i < code.length; i++)
				{
					//console.log("-")
					var div = document.createElement("div");
					var elements = tools.search(code[i], /\${data\["(.*?)"\]}|./g);
					for (var j = 0; j < elements.length; j++)
					{
						if (elements[j][0].match(/\${data\["(.*?)"\]}/))
						{
							if (text)
							{
								var text_node = document.createTextNode(text);
								div.appendChild(text_node);	
								text = "";
							}
							var ComponentClass = Vue.extend(text_columns);
							var instance = new ComponentClass({
								propsData: {
									value: elements[j][1],
									columns: this.columns,
									id: this.id
								},
							});
							instance.$on('mounted', (composant, id) => {
								self.ids["c-" + id] = composant;
							});
							instance.$on('del', (id) => {
								delete self.ids["c-" + id];
							});
							instance.$mount(); 
							var div_instance = document.createElement("div");
							div_instance.style["display"] = "inline-block";
							div_instance.id = "c-" + this.id;
							div_instance.class = "composant";
							div_instance.appendChild(instance.$el);
							div.appendChild(div_instance);	
							this.id++;
						}
						else
						{
							text += elements[j][0];
						}
					}
					if (text)
					{
						var text_node = document.createTextNode(text);
						div.appendChild(text_node);	
						text = "";
					}
					if (elements.length == 0)
					{
						var br = document.createElement("br");
						div.appendChild(br);
					}
					editor.appendChild(div);
				}

				var editor = document.getElementById("editor" + self.id_editor);
				if (editor.childNodes.length > 0)
				{
					if (editor.childNodes[editor.childNodes.length - 1].nodeName == "DIV" && !editor.childNodes[editor.childNodes.length - 1].class)
						editor = editor.childNodes[editor.childNodes.length - 1];
					if (editor.childNodes[editor.childNodes.length - 1].nodeName != "#text" || editor.childNodes[editor.childNodes.length - 1].textContent.length == 0)
					{
						var text = document.createTextNode("\u00A0");
						editor.appendChild(text);		
					}
				}
			},
			insert_column(column)
			{
				var self = this;
				//console.log(column)

				var ComponentClass = Vue.extend(text_columns);
				var instance = new ComponentClass({
					propsData: {
						value: column,
						columns: this.columns,
						id: this.id
					},
				});
				instance.$on('mounted', (composant, id) => {
					self.ids["c-" + id] = composant;
				});
				instance.$on('del', (id) => {
					delete self.ids["c-" + id];
				});
				instance.$mount(); 

				var div = document.createElement("div");
				div.style["display"] = "inline-block";
				div.id = "c-" + this.id;
				div.class = "composant";
				div.appendChild(instance.$el);

				var editableDiv = this.$refs.editor;
				var range = document.createRange();
				var sel = window.getSelection();
				range = sel.getRangeAt(0);
				console.log(sel)
				if (sel.anchorNode.id != "editor" + this.id_editor && sel.getRangeAt(0).endContainer.parentNode.id !== "editor" + this.id_editor && sel.getRangeAt(0).endContainer.parentNode.parentNode.id !== "editor" + this.id_editor)
				{
					editableDiv.focus();
       				window.getSelection().selectAllChildren(editableDiv)
					window.getSelection().collapseToEnd()
					var sel = window.getSelection();
					range = sel.getRangeAt(0);
				}
				//console.log(sel.getRangeAt(0).endContainer.parentNode.id)
				range.insertNode(div);

				var editor = document.getElementById("editor" + this.id_editor);
				if (editor.childNodes.length > 0)
				{
					if (editor.childNodes[editor.childNodes.length - 1].nodeName == "DIV" && !editor.childNodes[editor.childNodes.length - 1].class)
						editor = editor.childNodes[editor.childNodes.length - 1];
					if (editor.childNodes[editor.childNodes.length - 1].nodeName != "#text" || editor.childNodes[editor.childNodes.length - 1].textContent.length == 0)
					{
						//console.log(editor)
						var text = document.createTextNode("\u00A0");
						editor.appendChild(text);		
					}
				}

				range.setStartAfter(div);
				sel.removeAllRanges();
				sel.addRange(range);
				editableDiv.focus();

				this.id++;
			},
		},
		mounted: async function () {

            var self = this;

			document.getElementById("editor" + this.id_editor).addEventListener("input", function() {
				var editor = document.getElementById("editor" + self.id_editor);
				if (editor.childNodes.length > 0)
				{
					if (editor.childNodes[editor.childNodes.length - 1].nodeName == "DIV" && !editor.childNodes[editor.childNodes.length - 1].class)
						editor = editor.childNodes[editor.childNodes.length - 1];
					if (editor.childNodes[editor.childNodes.length - 1].nodeName != "#text" || editor.childNodes[editor.childNodes.length - 1].textContent.length == 0)
					{
						var text = document.createTextNode("\u00A0");
						editor.appendChild(text);
					}
				}
			}, false);
		},
	};
</script>

